import styled from 'styled-components';

import { ProductUnit } from '../../../../../../types/ProductUnit';
import { Text } from '../../../../../cdl/Text/Text';
import { Tooltip } from '../../../../../cdl/Tooltip/Tooltip';
import { calculateVolumeWithPrices } from '../../../../../common/helpers/calculate.utilities';
import { formatDateTime } from '../../../../../common/helpers/formatDateTime.helper';
import { formatPort } from '../../../../../common/helpers/formatPort.helper';
import { formatTotalPrice } from '../../../../../common/helpers/formatTotal.helper';
import { translate } from '../../../../../common/helpers/translate.helper';
import { Characters } from '../../../../../common/helpers/unicode.helper';
import { Box } from '../../../../../common/ui/Box';
import { theme } from '../../../../../common/ui/theme';
import { useRfqOfferCardContext } from '../../../components/RfqOfferCard/hooks/useRfqOfferCardContext';
import { PriceVolumeSubline } from '../../PriceVolumeSubline';

const RfqOfferPortAndTotalsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: ${theme.colors.border.muted};
    padding-bottom: ${theme.space[8]};
    gap: ${theme.space[16]};
`;

export const RfqOfferPortAndTotals = () => {
    const { offer } = useRfqOfferCardContext();

    const portName = offer.port ? formatPort({ port: offer.port }) : Characters.EN_DASH;

    return (
        <RfqOfferPortAndTotalsGrid>
            <Box display="flex" flexDirection="column">
                <Text variant="subtitle1" style={{ whiteSpace: 'nowrap' }}>
                    {portName}
                </Text>
                {offer.dateDelivery ? (
                    <div>
                        <Tooltip label={translate('offer.edit.coreData.dateDelivery')} showArrow side="right">
                            <Text variant="extraSmall" color="foreground.muted">
                                {formatDateTime({
                                    date: offer.dateDelivery,
                                    format: 'PP',
                                })}
                            </Text>
                        </Tooltip>
                    </div>
                ) : null}
            </Box>

            <Box display="flex" flexDirection="column" alignItems="end">
                <Text variant="subtitle1">{formatTotalPrice(offer.total)}</Text>

                {offer.ppl ? (
                    <PriceVolumeSubline
                        price={offer.ppl}
                        volume={calculateVolumeWithPrices(offer.items)}
                        unit={ProductUnit.L}
                    />
                ) : null}
            </Box>
        </RfqOfferPortAndTotalsGrid>
    );
};
